"use client";

import { useAuth } from "@/features/auth/hooks/useAuth";
import { PUBLIC_ROUTES } from "@/features/auth/utils";
import LogRocket from "logrocket";
import { useEffect } from "react";
import { t } from "@/lib/localization";

const excludedPaths = [...PUBLIC_ROUTES];

export default function InitLogRocket() {
    const { user } = useAuth();

    useEffect(() => {
        if (
            process.env.NEXT_PUBLIC_ENV !== "local" &&
            !excludedPaths.some((path) =>
                window.location.pathname.includes(path)
            )
        ) {
            LogRocket.init("osrolr/yedalabs");
        }
    }, []);

    useEffect(() => {
        if (user?.id) {
            LogRocket.identify(user.id, {
                email: user.email || "",
                name: user.name || "",
                admin: user.admin || false,
                env: process.env.NEXT_PUBLIC_ENV || "",
            });
        }
    }, [user]);

    return <></>;
}
